module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6vQiz1mEGDV6M9UgbVWHUC-daf40271e09e84f783fe30130b0d4abc.jpg";